module.exports = __webpack_public_path__ + "assets/img/slide02.7cb06cba.svg";